import '../../App.css';
import React, { useContext } from "react";
import { ApiContext } from '../../context/ApiContext';
import { IoIosWarning } from "react-icons/io";
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';

function ModalBSCPadrao({ cicloDemandaKey }) {

    const { setModalBSCPadrao, SalvarBSC, BSCDados, BSCPadrao } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    const salvar = () => {
         const bscAtualizado = {
            ...BSCDados,
        }
        SalvarBSC(bscAtualizado)
    }
    const salvarBSCPadrao = async () => {
        const bscAtualizado = {
            ...BSCDados,
            padrao: true,
        }

        await SalvarBSC(bscAtualizado)
        BSCPadrao(BSCDados.bscKey, BSCDados.cicloDemandaKey)
    }

    return (
        <div className="modal-novo">
            <div className="modal-interno-delete">
                <div className="modal-content-delete">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '20px', padding: '16px' }} className='border-bottom'>
                        <div>
                            <IoIosWarning style={{ color: '#FACC15', marginRight: '5px' }} /> BSC padrão
                        </div>
                        <button className='btn-fechar' onClick={() => setModalBSCPadrao(false)}>
                            <FaTimes />
                        </button>
                    </div>
                    <div style={{ padding: '16px' }} className='border-bottom'>
                        Este BSC não é o padrão. Deseja marcar este como padrão?
                    </div>
                    <div className="content-buttons">
                        <button type="submit" className="btn-dash btn-ver" style={btnVer} onClick={() => salvar()}>Cancelar</button>
                        <button type="submit" className="btn-dash btn-criar" style={btnCriar} onClick={() => salvarBSCPadrao()}>Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalBSCPadrao